<div class="plg-wrap">

  @if (loading) {
    <div class="plg-skeleton">
      <div class="plg-sk-title"></div>
      <div class="plg-sk-canvas"></div>
    </div>
  }

  @if (!loading && config) {

    <!-- Header -->
    <div class="plg-header">
      <div class="plg-header__left">
        <span class="plg-title">Planograma virtual</span>
        <span class="plg-subtitle">Posición espacial de objetos detectados · sin imagen</span>
      </div>
      <!-- Stats rápidos del reconocimiento actual -->
      @if (currentRow) {
        <div class="plg-quick-stats">
          @for (t of tags; track t.key) {
            <div class="plg-qs" [style.--tc]="t.color">
              <span class="plg-qs__val">{{ tagCount(t.key) }}</span>
              <span class="plg-qs__lbl">{{ t.label }}</span>
            </div>
          }
        </div>
      }
    </div>

    <!-- Tag filter -->
    <div class="plg-tag-bar">
      @for (t of tags; track t.key) {
        <button type="button" class="plg-tag-btn"
                [class.is-active]="isTagActive(t.key)"
                [style.--tc]="t.color"
                (click)="toggleTag(t.key)">
          <span class="plg-tag-swatch" [style.background]="t.color"></span>
          {{ t.label }}
        </button>
      }
    </div>

    <!-- Canvas + navegación -->
    <div class="plg-body">

      <!-- Flecha anterior -->
      <button type="button" class="plg-nav plg-nav--prev"
              [disabled]="currentIdx === 0"
              (click)="prev()">
        <i class="pi pi-chevron-left"></i>
      </button>

      <!-- Canvas wrap (para el tooltip) -->
      <div class="plg-canvas-outer" #canvasWrap>
        <canvas #planCanvas class="plg-canvas" width="500" height="760"></canvas>

        <!-- Tooltip hover -->
        @if (tooltip.visible) {
          <div class="plg-tooltip"
               [style.left.px]="tooltip.x"
               [style.top.px]="tooltip.y">
            <span class="plg-tooltip__name">{{ tooltip.name }}</span>
            <span class="plg-tooltip__tag" [style.color]="tooltip.tagColor">{{ tooltip.tag }}</span>
            <span class="plg-tooltip__score">{{ scorePct(tooltip.score) }} confianza</span>
          </div>
        }
      </div>

      <!-- Flecha siguiente -->
      <button type="button" class="plg-nav plg-nav--next"
              [disabled]="currentIdx === totalRows - 1"
              (click)="next()">
        <i class="pi pi-chevron-right"></i>
      </button>

    </div>

    <!-- Dots de navegación -->
    @if (totalRows > 1) {
      <div class="plg-dots">
        @for (_ of config.rows; track trackByIdx($index)) {
          <button type="button" class="plg-dot"
                  [class.is-active]="currentIdx === $index"
                  (click)="goTo($index)">
          </button>
        }
      </div>
    }

    <!-- Leyenda -->
    <div class="plg-legend">
      <span class="plg-legend__item">
        <span class="plg-legend__swatch" style="opacity:.2"></span> Baja confianza
      </span>
      <span class="plg-legend__item">
        <span class="plg-legend__swatch" style="opacity:.6"></span> Media
      </span>
      <span class="plg-legend__item">
        <span class="plg-legend__swatch"></span> Alta confianza
      </span>
      <span class="plg-legend__note">
        Opacidad del relleno proporcional al score · Hover para detalle
      </span>
    </div>

  }

</div>
